import React, { forwardRef } from "react";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";
import { formatearValor } from "../../../helpers/formatearPesos";
import dayjs from "dayjs";

export const PrintAssetsUser = forwardRef(({ data: { data, observaciones } }, ref) => {
    
	return (
        <div 
            ref={ ref }
            style={{ width: '100vw', height: '100dvh', padding: 30 }}
        >
            { /*ENCABEZADO*/ }
            <div style={{ display: 'flex', border: '1px solid #000' }}>
                <div style={{ flex: '1 1 0', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5 }}>
                    <img src={ require('../../../assets/img/camara.png') } alt="logo" width={150}  />
                </div>

                <div style={{ flex: '2 1 0', borderLeft: '1px solid #000', borderRight: '1px solid #000', display: 'flex', flexFlow: 'column noWrap', justifyContent: 'center', alignItems: 'center', padding: 5 }}>
                    <h4 style={{ textAlign: 'center' }}>CÁMARA DE COMERCIO DE CARTAGO</h4>
                    <h5  style={{ textAlign: 'center' }}>FORMATO PARA EL CONTROL DE ACTIVOS FIJOS</h5>
                </div>

                <div style={{ flex: '1 1 0' }}>
                    <div style={{ padding: 5 }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>
                            Código:
                            <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 5 }}>GR-F-038</span>
                        </label>
                    </div>
                    <div style={{ borderTop: '1px solid #000', borderBottom: '1px solid #000', padding: 5 }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>
                            Versión:
                            <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 5 }}>003</span>
                        </label>
                    </div>
                    <div style={{ padding: 5 }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>
                            Fecha:
                            <span style={{ fontSize: 12, fontWeight: 400, marginLeft: 5 }}>Marzo 10 de 2022</span>
                        </label>
                    </div>
                </div>
            </div>
            { /*ENCABEZADO*/ }


            { /*RESPONSABLE*/ }
            <div style={{ borderLeft: '1px solid #000', borderRight: '1px solid #000', padding: 10, display: 'flex', flexFlow: 'column', gap: 5 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: 5, flex: '2 1 0' }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>Responsable/Cargo:</label>
                        <span style={{ fontSize: 12 }}>{ convertirLetraMayus(data[0]?.responsable?.usuario?.nombre, true) }</span>
                    </div>
                    
                    <div style={{ display: 'flex', gap: 5, flex: '2 1 0' }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>Fecha:</label>
                        <span style={{ fontSize: 12 }}>{ dayjs().format('DD-MM-YYYY') }</span>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', gap: 5, flex: '2 1 0' }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>Custodio/Cargo:</label>
                        <span style={{ fontSize: 12 }}>{ convertirLetraMayus(data[0]?.responsable?.usuario?.nombre, true) }</span>
                    </div>

                    <div style={{ display: 'flex', gap: 5, flex: '2 1 0' }}>
                        <label style={{ fontSize: 12, fontWeight: 600 }}>Area:</label>
                        <span style={{ fontSize: 12 }}>{ convertirLetraMayus(data[0]?.responsable?.usuario?.area?.nombre, true) }</span>
                    </div>
                </div>
            </div>
            { /*RESPONSABLE*/ }

            { /*TABLA*/ }
            <table style={{ border: '1px solid #000', borderCollapse: 'collapse', width: '100%' }}>
                <tbody>
                    <tr style={{ fontSize: 12, textAlign: 'center' }}>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Código</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10, flex: '3 1 0', minWidth: 200 }}>Descripción</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Serial</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Placa</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Cantidad</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Valor</th>
                        <th style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 10 }}>Observaciones</th>
                    </tr>

                    {
                        data?.map(a => (
                            <tr key={ a?._id } style={{ fontSize: 12, textAlign: 'center' }}>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>{ a?.codigo_inteligente }</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5, flex: '3 1 0', minWidth: 200, wordWrap: 'break-word' }}>{ convertirLetraMayus(a?.descripcion) }</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>N/A</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>{ a?.placa }</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>1</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>${ formatearValor(a?.valor_compra) }</td>
                                <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>{ convertirLetraMayus(a?.observacion) }</td>
                            </tr>
                        ))
                    }
                    
                    <tr style={{ fontSize: 12, fontWeight: 600 }}>
                        <td colSpan={4} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>
                            TOTAL ACTIVOS A SU CARGO Y VALORIZACIÓN
                        </td>
                        <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5, textAlign: 'center' }}>{ data?.length }</td>
                        <td style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5, textAlign: 'center' }}>
                            ${ formatearValor(data?.reduce((acu, v) => acu + v?.valor_compra, 0)) }
                        </td>
                    </tr>

                    <tr style={{ fontSize: 12, fontWeight: 600 }}>
                        <td colSpan={7} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5 }}>
                            OBSERVACIONES:
                            <p style={{ fontSize: 12, fontWeight: 'normal', textAlign: 'justify' }}>{ convertirLetraMayus(observaciones) }</p>
                        </td>
                    </tr>

                    <tr style={{ fontSize: 12, fontWeight: 600 }}>
                        <td colSpan={4} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: '5px 0px 40px 5px' }}>
                            RECIBIDO POR:
                        </td>
                    
                        <td colSpan={3} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: '5px 0px 40px 5px' }}>
                            FECHA DE RECIBIDO:
                        </td>
                    </tr>

                    <tr style={{ fontSize: 12, fontWeight: 600 }}>
                        <td colSpan={7} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: '5px 0px 40px 5px', textAlign: 'center' }}>
                            FIRMA DE DIRECCIÓN ADMINISTRATIVA Y FINANCIERA
                        </td>
                    </tr>

                    <tr style={{ fontSize: 10 }}>
                        <td colSpan={7} style={{ border: '1px solid #000', borderCollapse: 'collapse', padding: 5, textAlign: 'justify' }}>
                            <p style={{ marginBottom: 5 }}>
                            Al firmar este documento la persona se hace responsable por los activos que se encuentran a su cargo. Cualquier daño, pérdida o traslado debe ser informada a la Dirección Administrativa y Financiera, para proceder a incluirlo en el módulo de activos fijos. Igualmente con el presente documento autorizo a la Cámara de Comercio de Cartago para que descuente de las prestaciones sociales, salarios e indemnizaciones a que pueda tener derecho por los daños o pérdidas de los elementos de trabajo entregados. (Artículo 149 del Código sustantivo del Trabajo).
                            </p>

                            <p>
                                En caso de que el responsable de los activos sea diferente al custodio, este último deberá firmar en la casilla de observación, en señal de aceptación, haciendo la aclaración respectiva.
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
});